module.exports = __webpack_public_path__ + "c61ab02d20f4e284d234a5f0a441d210.svg";